// ANGULAR DEPENDANCY
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { NOTIFICATION_API_URL } from '../../../../constants/api/notification';
import { APIUtil } from '../../../../core/utils/api-util';
import { ApiPayload } from '../../../../models/common/api/api-payload.interface';
import { ApiResponse } from '../../../../models/common/api/api-response.interface';
import { ApiConfigService } from '../../../core/services/api-config/api-config.service';
import { BaseService } from '../../../core/services/base/base.service';
import { TokenStorageService } from '../../../core/services/token-storage/token-storage.service';


/**
 * This service is for Notification api calls
 * For handle Notification api calls
 *
 * @author Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>
 *
 * Notes:-
 * Date: 27/04/2020 (Vikas Thakkar <vikas.thakkar@saeculumsolutions.com>) initially created Notification
 */
@Injectable()
export class NotificationService extends BaseService {

  constructor(
    protected httpClient: HttpClient,
    protected tokenStorage: TokenStorageService,
    public apiConfig: ApiConfigService) {
    super(httpClient, tokenStorage);
  }


  /**
   *  get all NotificationReplacer Attribute
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public getNotificationReplacerAll(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${NOTIFICATION_API_URL.NOTIFICATION_REPLACER}/all`;
    return this.get(url);
  }

  /**
   *  get NotificationReplacer Attribute by pagging
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public getNotificationReplacerPagging(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${NOTIFICATION_API_URL.NOTIFICATION_REPLACER}/paging`;
    return this.post(url, payload);
  }


  /**
  *  get NotificationReplacer Attribute by id
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public getNotificationReplacer(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['id'];
    // get url
    const url = APIUtil.getReplaceParams(`${this.apiConfig.getApiUrl()}${NOTIFICATION_API_URL.NOTIFICATION_REPLACER}/{{id}}`, replaceParams, payload);
    return this.get(url);
  }

  /**
    *  add NotificationReplacer Attribute
    * @param payload : Api  payload object
    * @returns Observable<ApiResponse>
    */
  public addNotificationReplacer(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${NOTIFICATION_API_URL.NOTIFICATION_REPLACER}`;
    return this.post(url, payload);
  }

  /**
  *  update NotificationReplacer Attribute
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public updateNotificationReplacer(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${NOTIFICATION_API_URL.NOTIFICATION_REPLACER}`;
    return this.put(url, payload);
  }

  /**
  *  get NotificationReplacer Attribute
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public deleteNotificationReplacer(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['id'];
    // get url
    const url = APIUtil.getReplaceParams(`${this.apiConfig.getApiUrl()}${NOTIFICATION_API_URL.NOTIFICATION_REPLACER}/{{id}}`, replaceParams, payload);
    return this.delete(url);
  }

/////////// -- TEMPLATE-- ///////////


  /**
   *  get all NotificationMasterTemplate Attribute
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public getNotificationMasterTemplateAll(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${NOTIFICATION_API_URL.NOTIFICATION_MATER_TEMPLATE}/all`;
    return this.get(url);
  }

  /**
   *  get NotificationMasterTemplate Attribute by pagging
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public getNotificationMasterTemplatePagging(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${NOTIFICATION_API_URL.NOTIFICATION_MATER_TEMPLATE}/paging`;
    return this.post(url, payload);
  }


  /**
  *  get NotificationMasterTemplate Attribute by id
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public getNotificationMasterTemplate(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['id'];
    // get url
    const url = APIUtil.getReplaceParams(`${this.apiConfig.getApiUrl()}${NOTIFICATION_API_URL.NOTIFICATION_MATER_TEMPLATE}/{{id}}`, replaceParams, payload);
    return this.get(url);
  }

  /**
    *  add NotificationMasterTemplate Attribute
    * @param payload : Api  payload object
    * @returns Observable<ApiResponse>
    */
  public addNotificationMasterTemplate(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${NOTIFICATION_API_URL.NOTIFICATION_MATER_TEMPLATE}`;
    return this.post(url, payload);
  }

  /**
  *  update NotificationMasterTemplate Attribute
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public updateNotificationMasterTemplate(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${NOTIFICATION_API_URL.NOTIFICATION_MATER_TEMPLATE}`;
    return this.put(url, payload);
  }

  /**
  *  get NotificationMasterTemplate Attribute
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public deleteNotificationMasterTemplate(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['id'];
    // get url
    const url = APIUtil.getReplaceParams(`${this.apiConfig.getApiUrl()}${NOTIFICATION_API_URL.NOTIFICATION_MATER_TEMPLATE}/{{id}}`, replaceParams, payload);
    return this.delete(url);
  }

/////////// -- TEMPLATE-- ///////////


  /**
   *  get all NotificationTemplate Attribute
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public getNotificationTemplateAll(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${NOTIFICATION_API_URL.NOTIFICATION_TEMPLATE}/all`;
    return this.get(url);
  }

  /**
   *  get NotificationTemplate Attribute by pagging
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public getNotificationTemplatePagging(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${NOTIFICATION_API_URL.NOTIFICATION_TEMPLATE}/paging`;
    return this.post(url, payload);
  }


  /**
  *  get NotificationTemplate Attribute by id
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public getNotificationTemplate(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['id'];
    // get url
    const url = APIUtil.getReplaceParams(`${this.apiConfig.getApiUrl()}${NOTIFICATION_API_URL.NOTIFICATION_TEMPLATE}/{{id}}`, replaceParams, payload);
    return this.get(url);
  }

  /**
    *  add NotificationTemplate Attribute
    * @param payload : Api  payload object
    * @returns Observable<ApiResponse>
    */
  public addNotificationTemplate(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${NOTIFICATION_API_URL.NOTIFICATION_TEMPLATE}`;
    return this.post(url, payload);
  }

  /**
  *  update NotificationTemplate Attribute
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public updateNotificationTemplate(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${NOTIFICATION_API_URL.NOTIFICATION_TEMPLATE}`;
    return this.put(url, payload);
  }

  /**
  *  get NotificationTemplate Attribute
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public deleteNotificationTemplate(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['id'];
    // get url
    const url = APIUtil.getReplaceParams(`${this.apiConfig.getApiUrl()}${NOTIFICATION_API_URL.NOTIFICATION_TEMPLATE}/{{id}}`, replaceParams, payload);
    return this.delete(url);
  }


  //// Module Activity ////

    /**
   *  get all ModuleActivity Attribute
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public getModuleActivityAll(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${NOTIFICATION_API_URL.MODULE_ACTIVITY}/all`;
    return this.get(url);
  }

  /**
   *  get ModuleActivity Attribute by pagging
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public getModuleActivityPagging(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${NOTIFICATION_API_URL.MODULE_ACTIVITY}/paging`;
    return this.post(url, payload);
  }


  /**
  *  get ModuleActivity Attribute by id
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public getModuleActivity(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['id'];
    // get url
    const url = APIUtil.getReplaceParams(`${this.apiConfig.getApiUrl()}${NOTIFICATION_API_URL.MODULE_ACTIVITY}/{{id}}`, replaceParams, payload);
    return this.get(url);
  }

  /**
    *  add ModuleActivity Attribute
    * @param payload : Api  payload object
    * @returns Observable<ApiResponse>
    */
  public addModuleActivity(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${NOTIFICATION_API_URL.MODULE_ACTIVITY}`;
    return this.post(url, payload);
  }

  /**
  *  update ModuleActivity Attribute
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public updateModuleActivity(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${NOTIFICATION_API_URL.MODULE_ACTIVITY}`;
    return this.put(url, payload);
  }

  /**
  *  get ModuleActivity Attribute
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public deleteModuleActivity(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['id'];
    // get url
    const url = APIUtil.getReplaceParams(`${this.apiConfig.getApiUrl()}${NOTIFICATION_API_URL.MODULE_ACTIVITY}/{{id}}`, replaceParams, payload);
    return this.delete(url);
  }


  /// Activity map


  /**
   *  get all NotificationActivitymap Attribute
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public getNotificationActivitymapAll(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${NOTIFICATION_API_URL.ACTIVITY_MAP}/all`;
    return this.get(url);
  }

  /**
   *  get NotificationActivitymap Attribute by pagging
   * @param payload : Api common payload object
   * @returns Observable<ApiResponse>
   */
  public getNotificationActivitymapPagging(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${NOTIFICATION_API_URL.ACTIVITY_MAP}/paging`;
    return this.post(url, payload);
  }


  /**
  *  get NotificationActivitymap Attribute by id
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public getNotificationActivitymap(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['id'];
    // get url
    const url = APIUtil.getReplaceParams(`${this.apiConfig.getApiUrl()}${NOTIFICATION_API_URL.ACTIVITY_MAP}/{{id}}`, replaceParams, payload);
    return this.get(url);
  }

  /**
    *  add NotificationActivitymap Attribute
    * @param payload : Api  payload object
    * @returns Observable<ApiResponse>
    */
  public addNotificationActivitymap(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${NOTIFICATION_API_URL.ACTIVITY_MAP}`;
    return this.post(url, payload);
  }

  /**
  *  update NotificationActivitymap Attribute
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public updateNotificationActivitymap(payload: ApiPayload): Observable<ApiResponse> {
    const url = `${this.apiConfig.getApiUrl()}${NOTIFICATION_API_URL.ACTIVITY_MAP}`;
    return this.put(url, payload);
  }

  /**
  *  get NotificationActivitymap Attribute
  * @param payload : Api common payload object
  * @returns Observable<ApiResponse>
  */
  public deleteNotificationActivitymap(payload: ApiPayload): Observable<ApiResponse> {
    const replaceParams = ['id'];
    // get url
    const url = APIUtil.getReplaceParams(`${this.apiConfig.getApiUrl()}${NOTIFICATION_API_URL.ACTIVITY_MAP}/{{id}}`, replaceParams, payload);
    return this.delete(url);
  }

}

